module.exports = __webpack_public_path__ + "static/Group 6726-260bce66eeea063e5873b31423ebf3c3.png";